<template>
  <OTable
    @list-query="lm = $event"
    :initial="lm"
    :pagination="false"
  />
</template>

<script setup>
import { computed, provide, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { commons } from '@provise/lib/transformer'
import { useApi } from '@provise/composables/api'
import { useUserStore } from '@provise/stores/user'
import OTable from '@/views/orders/list/table.vue'

const props = defineProps({
  filter: {
    type: String,
    default: 'my',
  },
})

const lm = ref({})
const userStore = useUserStore()
const { user } = storeToRefs(userStore)

const { model, refresh } = useApi({
  url: 'orders',
  data: [],
  watch: lm,
  //
  // @todo:
  //
  // replace order's computed total_count
  // to real backend value
  // when onpage:500 workaround fixed
  //
  query: { onPage: 500, page: 1, [props.filter]: true },
  pick: d => {
    const _d = d.data.map(d => {
      if (d.date_created) {
        d.fmt_date_created = commons.dateLocal(d.date_created, 'Pp')
      }
      return d
    })
    return _d
  },
})

const orders = computed(() => {
  const u = user.value || {}
  const t = props.filter || 'my'
  const o = model.value || []

  const orders = o.filter(o => {
    if (!u.id) {
      return false
    }
    if (t == 'my') {
      return o.assign_user?.id == u.id
    }
    if (o.assign_user) {
      return false
    }
    return (u.roles || []).some(r => r.id == o.assign_role?.id)
  })

  return { data: orders, total_count: orders.length }
})

provide('model', orders)
provide('refresh', refresh)
</script>
